export const handleUpdate = (event) => {
  if (
    event.target.value === 'Actualizar detalles' ||
    event.target.value === 'Actualizar configuraciones'
  ) {
    return true
  } else if (event.target.value === 'Cancelar') {
    return false
  }
}

const resolveTabLabel = (eventOrValue) => {
  if (typeof eventOrValue === 'string') {
    return eventOrValue
  }

  if (eventOrValue?.target?.tagName === 'A') {
    return eventOrValue.target.innerText
  }

  return null
}

export const handleTabClick = (eventOrValue, isEditing) => {
  const nextTab = resolveTabLabel(eventOrValue)
  if (!nextTab) return

  if (!isEditing) {
    return {
      activeTab: nextTab,
      editing: false
    }
  }

  const confirmation = window.confirm(
    '¿Está seguro que quiere continuar? Los cambios editados no serán guardados'
  )

  if (confirmation) {
    return {
      activeTab: nextTab,
      editing: false,
      confirm: confirmation
    }
  }

  return {
    activeTab: 'Detalles',
    editing: true,
    confirm: confirmation
  }
}
